import {
  LIST,
  CHECKBOXGROUP,
  RADIOGROUP,
  SELECT
} from '@/modules/form_builder/components/mixins/components-list';

export default {
  data: () => ({
    elements: LIST,
    multiple: [RADIOGROUP, CHECKBOXGROUP, SELECT]
  }),

  props: {
    languages: {
      type: Array,
      required: true
    }
  },

  methods: {
    getDefaultItemWithoutElements(type, name, title) {
      return {
        name: name,
        type: type,
        required: false,
        translations: this.languages.map(item => {
          return {
            language_id: item.id,
            name: title
          };
        })
      };
    },
    getDefaultItemWithElements(type, name, title, elTitle) {
      return {
        ...this.getDefaultItemWithoutElements(type, name, title),
        items: [
          this.getDefaultItemWithoutElements(type, name, elTitle),
          this.getDefaultItemWithoutElements(type, name, elTitle)
        ]
      };
    },

    getItem(
      type,
      name = '',
      title = '',
      elTitle = ''
    ) {
      if (this.multiple.includes(type)) {
        return this.getDefaultItemWithElements(type, name, title, elTitle);
      } else if (this.elements.includes(type)) {
        return this.getDefaultItemWithoutElements(type, name, title);
      } else {
        return {};
      }
    }
  }
};
